import { render, staticRenderFns } from "./editPosition.vue?vue&type=template&id=39164870&scoped=true"
import script from "./editPosition.vue?vue&type=script&lang=js"
export * from "./editPosition.vue?vue&type=script&lang=js"
import style0 from "./editPosition.vue?vue&type=style&index=0&id=39164870&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39164870",
  null
  
)

export default component.exports